import React from "react";
import { useDispatch } from "react-redux";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { SnackbarData, SnackbarType } from "../Snackbar";
import { generateUniqueNumber } from "../../shared/utility";
import { addSnackbar } from "../../store/actions";

export default function CopyBarcodeSerial({ barcode }: { barcode?: string | null }) {
  const dispatch = useDispatch();
  const text = String(barcode ?? "").trim();
  if (!text) return <span>—</span>;

  const copyBarcode = async () => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(addSnackbar(new SnackbarData(
        generateUniqueNumber(), "Barcode copied", SnackbarType.Success,
      )) as any);
    } catch {
      dispatch(addSnackbar(new SnackbarData(
        generateUniqueNumber(), "Could not copy barcode", SnackbarType.Error,
      )) as any);
    }
  };

  return (
    <button
      type="button"
      title="Copy barcode"
      aria-label={`Copy barcode ${text}`}
      className="inline-flex items-center gap-1.5 rounded-md text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#0F172A]"
      onClick={(event) => {
        event.stopPropagation();
        copyBarcode();
      }}
    >
      <span>{text.slice(-9)}</span>
      <ClipboardDocumentIcon className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}
